export default __webpack_public_path__ + "static/media/JASPE OJO DE HIERRO.fa8c1ebc.jpg";